import Cookies from 'js-cookie';
import { apiAction } from '../utils/index';

import {
  UNITCOMPANIONLOGSERVICING_ERROR,
  UNITCOMPANIONLOGSERVICING_IS_LOADING,
  GET_ALL_UNITCOMPANIONLOGSERVICING_SESSIONS,
  SET_UNITCOMPANIONLOGSERVICING_CURRENT_PAGE,
  SET_UNITCOMPANIONLOGSERVICING_SESSION,
  SET_UNITCOMPANIONLOGSERVICING_PROCEDURE_LOADING,
  SET_UNITCOMPANIONLOGSERVICING_PROCEDURE_DETAIL,
  UNITCOMPANIONLOGSERVICING_CLEANUP
} from '../constants/index';

const envName = process.env.REACT_APP_ENV_NAME_SHORT;
const WIDGET_CODE = 'UNIT_COMPANION_SERVICE_LOG_VIEW';

export const setUnitCompanionLogServicingErrorThunk = err => dispatch => {
  let messageCode = err && err.response && err.response.data && err.response.data.errorMessage;
  messageCode = messageCode && messageCode.replace('[400]=>', '');
  dispatch(setUnitCompanionLogServicingError(messageCode, true));
  setTimeout(() => {
    //Hide the banner
    dispatch(setUnitCompanionLogServicingError(messageCode, false));
  }, 2500);
};

export const setUnitCompanionLogServicingError = (messageCode, status) => ({
  type: UNITCOMPANIONLOGSERVICING_ERROR,
  payload: {
    data: {
      isOpSuccessful: false,
      showBanner: status,
      isLoading: false,
      displayMessageCode: messageCode || ''
    }
  }
});

export const setLoadingStatus = isLoading => ({
  type: UNITCOMPANIONLOGSERVICING_IS_LOADING,
  payload: { isLoading }
});

// List - GET /unitcompanionlog/services/list
export const getUnitCompanionLogServicingListThunk = filterObj => dispatch => {
  let orgId = Cookies.get(`selectedorganisationid-${envName}`) || 1;
  dispatch(getUnitCompanionLogServicingList(filterObj, orgId));
};

export const getUnitCompanionLogServicingList = (filterObj, orgId) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_UNITS}/unitcompanionlog/services/list`,
    data: {
      Offset: filterObj.offset,
      Limit: filterObj.limit,
      FilterUnitId: filterObj.filterUnitId,
      FilterFrom: filterObj.filterFrom,
      FilterTo: filterObj.filterTo,
      UserId: Cookies.get(`userid-${envName}`),
      ProfileId: Cookies.get(`selectedprofileid-${envName}`) || 0,
      OrganisationId: orgId
    },
    method: 'GET',
    onLoad: status => setLoadingStatus(status),
    onSuccess: retData => setUnitCompanionLogServicingListThunk(retData),
    onFailure: err => setUnitCompanionLogServicingErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    widgetcode: WIDGET_CODE
  });

export const setUnitCompanionLogServicingListThunk = retData => dispatch => {
  let messageCode = retData && retData.message;
  let sessions = (retData && retData.Sessions) || [];
  dispatch(setUnitCompanionLogServicingList(messageCode, sessions));
};

export const setUnitCompanionLogServicingList = (messageCode, sessions) => ({
  type: GET_ALL_UNITCOMPANIONLOGSERVICING_SESSIONS,
  payload: {
    data: {
      sessions,
      isLoading: false,
      displayMessageCode: messageCode,
      showBanner: false,
      isOpSuccessful: false
    }
  }
});

export const setCurrentPage = currentPage => ({
  type: SET_UNITCOMPANIONLOGSERVICING_CURRENT_PAGE,
  payload: { currentPage }
});

// Describe - GET /unitcompanionlog/services (session header + lightweight
// procedures list - no actions/photos, those are lazy-loaded on expand).
export const describeUnitCompanionLogServicingThunk = unitGuidedServiceSessionId => dispatch => {
  let orgId = Cookies.get(`selectedorganisationid-${envName}`) || 1;
  dispatch(describeUnitCompanionLogServicing(unitGuidedServiceSessionId, orgId));
};

export const describeUnitCompanionLogServicing = (unitGuidedServiceSessionId, orgId) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_UNITS}/unitcompanionlog/services`,
    data: {
      UnitGuidedServiceSessionId: unitGuidedServiceSessionId,
      UserId: Cookies.get(`userid-${envName}`),
      ProfileId: Cookies.get(`selectedprofileid-${envName}`) || 0,
      OrganisationId: orgId
    },
    method: 'GET',
    onLoad: status => setLoadingStatus(status),
    onSuccess: retData => setUnitCompanionLogServicingSessionThunk(retData),
    onFailure: err => setUnitCompanionLogServicingErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    widgetcode: WIDGET_CODE
  });

export const setUnitCompanionLogServicingSessionThunk = retData => dispatch => {
  dispatch(
    setUnitCompanionLogServicingSession(retData && retData.Session, (retData && retData.Procedures) || [])
  );
};

export const setUnitCompanionLogServicingSession = (selectedSession, procedures) => ({
  type: SET_UNITCOMPANIONLOGSERVICING_SESSION,
  payload: { selectedSession: selectedSession || {}, procedures }
});

// Lazy-loaded procedure detail - GET /unitcompanionlog/services/procedure,
// called only when the front-end expands that procedure.
export const getUnitCompanionLogServicingProcedureThunk = guidedServiceProcedureId => dispatch => {
  let orgId = Cookies.get(`selectedorganisationid-${envName}`) || 1;
  dispatch(setProcedureLoading(guidedServiceProcedureId));
  dispatch(getUnitCompanionLogServicingProcedure(guidedServiceProcedureId, orgId));
};

export const setProcedureLoading = guidedServiceProcedureId => ({
  type: SET_UNITCOMPANIONLOGSERVICING_PROCEDURE_LOADING,
  payload: { guidedServiceProcedureId }
});

export const getUnitCompanionLogServicingProcedure = (guidedServiceProcedureId, orgId) =>
  apiAction({
    url: `${process.env.REACT_APP_API_ENDPOINT_UNITS}/unitcompanionlog/services/procedure`,
    data: {
      GuidedServiceProcedureId: guidedServiceProcedureId,
      UserId: Cookies.get(`userid-${envName}`),
      ProfileId: Cookies.get(`selectedprofileid-${envName}`) || 0,
      OrganisationId: orgId
    },
    method: 'GET',
    onSuccess: retData => setUnitCompanionLogServicingProcedureDetailThunk(retData),
    onFailure: err => setUnitCompanionLogServicingProcedureErrorThunk(err),
    accessToken: Cookies.get(`access-${envName}`),
    widgetcode: WIDGET_CODE
  });

export const setUnitCompanionLogServicingProcedureDetailThunk = retData => dispatch => {
  dispatch(
    setUnitCompanionLogServicingProcedureDetail(
      retData && retData.GuidedServiceProcedureId,
      (retData && retData.Actions) || [],
      (retData && retData.Photos) || []
    )
  );
};

export const setUnitCompanionLogServicingProcedureDetail = (guidedServiceProcedureId, actions, photos) => ({
  type: SET_UNITCOMPANIONLOGSERVICING_PROCEDURE_DETAIL,
  payload: { guidedServiceProcedureId, actions, photos }
});

// A failed procedure-detail fetch shouldn't take over the whole page's
// banner/loading state the way a failed list/describe call does - it only
// clears the per-procedure spinner so the accordion item can show its own
// inline retry state.
export const setUnitCompanionLogServicingProcedureErrorThunk = err => dispatch => {
  dispatch(setProcedureLoading(null));
  dispatch(setUnitCompanionLogServicingErrorThunk(err));
};

export const cleanUpThunk = retData => dispatch => {
  dispatch(cleanUp(retData));
};

export const cleanUp = retData => ({
  type: UNITCOMPANIONLOGSERVICING_CLEANUP,
  payload: retData
});
